// extracted by mini-css-extract-plugin
module.exports = {"tablePreview":"packingPreview_tablePreview__lOu0k","tableHeader":"packingPreview_tableHeader__2YMB6"};